export const LABELS = {
  gender: {
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  qualification: {
    '10th': '10th',
    '12th_dip': '12th / Diploma',
    bca_bsc: 'BCA / BSc',
    be_btech: 'BE / BTech',
    mca_mtech: 'MCA / MTech',
    other: 'Other',
  },
  currentStatus: {
    student_pursuing: 'Student (Pursuing)',
    recent_graduate: 'Recent Graduate',
    working_professional: 'Working Professional',
    career_break: 'Career Break',
  },
  experience: {
    fresher: 'Fresher',
    less_than_1: '< 1 Year',
    '1_to_3': '1–3 Years',
    '3_to_5': '3–5 Years',
    '5_plus': '5+ Years',
  },
  course: {
    mern: 'MERN Stack (Full Stack)',
    spring_boot: 'Java Spring Boot (Full Stack)',
    both_undecided: 'Both / Undecided',
  },
  batchMode: {
    weekday_morning: 'Weekday – Morning',
    weekday_evening: 'Weekday – Evening',
    weekend: 'Weekend',
    online_live: 'Online (Live)',
  },
  hearAboutUs: {
    referral: 'Referral',
    social_media: 'Social Media',
    google: 'Google',
    alumni: 'Alumni',
    other: 'Other',
  },
  primaryGoal: {
    first_job: 'First Job',
    switch: 'Switch',
    upgrade: 'Upgrade',
    freelance: 'Freelance',
  },
  lookingFor: {
    first_job: 'First Job',
    career_switch: 'Career Switch',
    salary_hike: 'Salary Hike',
    skill_upgrade: 'Skill Upgrade',
    freelancing: 'Freelancing',
    startup: 'Startup',
  },
  relocate: {
    yes: 'Yes',
    no: 'No',
    depends: 'Depends',
  },
  skillLevel: {
    not_aware: 'Not Aware',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    confident: 'Confident',
  },
  skill: {
    programming_fundamentals: 'Programming Fundamentals',
    dsa: 'DSA',
    html_css: 'HTML & CSS',
    javascript: 'JavaScript',
    react: 'React.js',
    node_express: 'Node.js / Express',
    databases: 'Databases (SQL / MongoDB)',
    core_java: 'Core Java',
    git: 'Git / Version Control',
  },
  status: {
    new: 'New',
    contacted: 'Contacted',
    follow_up: 'Follow Up',
    converted: 'Converted',
    lost: 'Lost',
  },
  interestLevel: {
    hot: 'Hot',
    warm: 'Warm',
    cold: 'Cold',
  },
};

export const SKILL_LIST = Object.keys(LABELS.skill);

export const defaultFormValues = {
  personal: {
    fullName: '',
    dateOfBirth: '',
    gender: '',
    mobile: '',
    whatsapp: '',
    email: '',
    address: { city: '', state: '' },
  },
  education: {
    highestQualification: '',
    highestQualificationOther: '',
    currentStatus: '',
    collegeName: '',
    branch: '',
    yearOfPassing: new Date().getFullYear(),
    cgpaOrPercentage: '',
  },
  work: {
    totalExperience: '',
    lastCompany: '',
    lastDesignation: '',
    knownSkills: '',
  },
  coursePreference: {
    courseInterested: '',
    batchMode: '',
    preferredStartMonth: '',
    hearAboutUs: '',
    hearAboutUsOther: '',
    primaryGoalAfterCourse: '',
  },
  careerGoals: {
    whyJoin: '',
    careerGoal2To3Years: '',
    lookingFor: [],
    expectedSalaryLpa: '',
    willingToRelocate: '',
  },
  skillRatings: SKILL_LIST.map((skill) => ({ skill, level: '' })),
  declaration: { accepted: false },
};
